import React from 'react';
import CreateQuoteForm from './create-quote-form';
import QuotesList from './quotes-list';
import Skeleton from '../../../../../components/Skeleton';
import LoginPrompt from '../login-prompt';

const QuotesSection = React.memo(({postId, isAuthorized, currentUserId}) => {
    const [lastCreatedQuoteId, setLastCreatedQuoteId] = React.useState(null);
    const [showLoginPrompt, setShowLoginPrompt] = React.useState(false);

    const handleShowLoginPrompt = React.useCallback(() => {
        setShowLoginPrompt(true);
    }, []);

    return (
        <div className='padding-top-1rem padding-left-2rem'>
            <div className='padding-top-1rem padding-bottom-1rem padding-left-1rem border-left-style-solid border-left-width-0dot125rem border-left-color-gray-300'>
                <div className='position-relative'>
                    <div
                        className='position-absolute top-1dot25rem border-bottom-style-solid border-bottom-width-0dot125rem border-bottom-color-gray-500 pointer-events-none'
                        style={{left: '-0.8rem', width: '0.6rem'}}
                    />
                    <CreateQuoteForm
                        quotedPostId={postId}
                        isAuthorized={isAuthorized}
                        onShowLoginPrompt={handleShowLoginPrompt}
                        onQuoteCreated={(newId) => {
                            if (newId) setLastCreatedQuoteId(newId);
                        }}
                    />
                    {showLoginPrompt && (
                        <LoginPrompt postId={postId} />
                    )}
                </div>
                <React.Suspense fallback={
                    <div className='padding-1rem'>
                        <Skeleton/>
                    </div>
                }>
                    <div className='padding-top-1rem mw768-padding-top-1dot5rem'>
                        <QuotesList 
                            postId={postId}
                            currentUserId={currentUserId}
                            isAuthorized={isAuthorized}
                            highlightId={lastCreatedQuoteId}
                        />
                    </div>
                </React.Suspense>
            </div>
        </div>
    );
});

export default QuotesSection;


